export default "__VITE_ASSET__F1byJOg4__"